import React from 'react';
import { Mail, Smartphone, MessageCircle } from 'lucide-react';

interface MessageBubbleProps {
  id: string;
  sender: string;
  role: 'staff' | 'student';
  body: string;
  timestamp: string;
  channel: 'in_platform' | 'email' | 'sms';
}

export default function MessageBubble({ sender, role, body, timestamp, channel }: MessageBubbleProps) {
  const ChannelIcon =
    channel === 'in_platform' ? MessageCircle : channel === 'email' ? Mail : Smartphone;
  return (
    <div className="flex items-start space-x-3">
      <div className="flex-shrink-0">
        <div className="h-8 w-8 rounded-full bg-gray-300 dark:bg-gray-700 flex items-center justify-center">
          {sender.charAt(0)}
        </div>
      </div>
      <div className="flex-1">
        <div className="flex items-center space-x-2 text-sm">
          <span className="font-medium text-gray-800 dark:text-gray-200 flex items-center space-x-1">
            <span>{sender}</span>
            <span
              className={
                role === 'student'
                  ? 'rounded bg-blue-100 px-2 text-xs font-semibold text-blue-800'
                  : 'rounded bg-green-100 px-2 text-xs font-semibold text-green-800'
              }
            >
              {role === 'student' ? 'Student' : 'Staff'}
            </span>
          </span>
          <ChannelIcon size={14} className="text-gray-400" />
          <span className="text-gray-500">{timestamp}</span>
        </div>
        <div className="mt-1 text-gray-700 dark:text-gray-200">{body}</div>
      </div>
    </div>
  );
}